Dygraph.Plugins.TrovisInteraction = function () {
    var interactionModel;
    var DRAG_EDGE_MARGIN = 100;
    var self = this;

    // copied from dygraph-interaction-model
    var distanceFromChart = function (event, g) {
        var chartPos = Dygraph.findPos(g.canvas_);
        var box = {
            left: chartPos.x,
            right: chartPos.x + g.canvas_.offsetWidth,
            top: chartPos.y,
            bottom: chartPos.y + g.canvas_.offsetHeight,
        };

        var pt = {
            x: Dygraph.pageX(event),
            y: Dygraph.pageY(event),
        };

        var dx = distanceFromInterval(pt.x, box.left, box.right),
            dy = distanceFromInterval(pt.y, box.top, box.bottom);
        return Math.max(dx, dy);
    };

    // copied from dygraph-interaction-model
    var distanceFromInterval = function (x, left, right) {
        if (x < left) {
            return left - x;
        } else if (x > right) {
            return x - right;
        } else {
            return 0;
        }
    };

    var getTouches = function (event, g, context) {
        var touches = [];
        var chartOffset = $(g.hidden_).offset();

        for (var i = 0; i < event.touches.length; i++) {
            var t = event.touches[i];

            // we dispense with 'dragGetX_' because all touchBrowsers support pageX
            touches.push({
                pageX: t.pageX,
                pageY: t.pageY,
                dataX: g.toDataXCoord(t.pageX - chartOffset.left),
                dataY: g.toDataYCoord(t.pageY - chartOffset.top),
                convertedDataX: (t.pageX - chartOffset.left) * context.conversionRatioX + context.conversionOffsetX,
                convertedDataY: (t.pageY - chartOffset.top) * context.conversionRatioY + context.conversionOffsetY,
            });
        }

        return touches;
    };

    var normalizeRatio = function (r) {
        if (isNaN(r)) return 1;
        return Math.min(Math.max(r, -1000), 1000);
    };

    // copied from dygraph-interaction-model and MODIFIED
    // MOD BEGIN
    Dygraph.Interaction.startTouch = function (event, g, context) {
        event.preventDefault(); // touch browsers are all nice.
        if (event.touches.length > 1) {
            // If the user ever puts two fingers down, it's not a double tap.
            context.startTimeForDoubleTapMs = null;
        }

        if (g.dateWindow_) {
            if (typeof g.dateWindow_[0] == 'object') {
                g.dateWindow_[0] = g.dateWindow_[0].getTime();
                g.dateWindow_[1] = g.dateWindow_[1].getTime();
            }
        }

        var touches = getTouches(event, g, context);

        // save the math function to convert pixels to dates/values according to current settings (before touching)
        context.conversionRatioY = g.toDataYCoord(1) - g.toDataYCoord(0);
        context.conversionOffsetY = g.toDataYCoord(0);
        context.conversionRatioX = g.toDataXCoord(1) - g.toDataXCoord(0);
        context.conversionOffsetX = g.toDataXCoord(0);
        context.initialTouches = touches;
        context.valueRange = [g.axes_[0].valueRange[0], g.axes_[0].valueRange[1]];

        var valueWindow = g.axes_[0].valueWindow
            ? [g.axes_[0].valueWindow[0], g.axes_[0].valueWindow[1]]
            : [context.valueRange[0], context.valueRange[1]];

        context.initialValueWindow = [
            Math.min(valueWindow[0], valueWindow[1]),
            Math.max(valueWindow[0], valueWindow[1]),
        ];

        context.dateRange = [new Date(g.file_[0][0]).getTime(), new Date(g.file_[g.file_.length - 1][0]).getTime()];
        var dateWindow = $.extend([], false, context.dateRange);
        if (g.dateWindow_ && g.dateWindow_.length == 2) {
            dateWindow = [g.dateWindow_[0], g.dateWindow_[1]];
        }
        context.initialDateWindow = [Math.min(dateWindow[0], dateWindow[1]), Math.max(dateWindow[0], dateWindow[1])];

        context.initialValueWindowSize = Math.abs(valueWindow[1] - valueWindow[0]);
        context.initialDateWindowSize = Math.abs(context.initialDateWindow[1] - context.initialDateWindow[0]);

        if (touches.length == 1) {
            // This is just a swipe.
            context.touchDirections = { x: true, y: true };
        } else if (touches.length >= 2) {
            var differenceVertical =
                Math.abs(touches[0].pageY - touches[1].pageY) /
                Math.abs(initialTouches[0].pageY - initialTouches[1].pageY);
            var differenceHorizontal =
                Math.abs(touches[0].pageX - touches[1].pageX) /
                Math.abs(initialTouches[0].pageX - initialTouches[1].pageX);
            var isHorizontalPinch = differenceHorizontal > differenceVertical;
            context.touchDirections = { x: isHorizontalPinch, y: !isHorizontalPinch };
        }

        this.selectByTouch(touches[0].pageX, touches[0].pageY, g);
        // MOD END
    };

    // copied from dygraph-interaction-model and MODIFIED
    Dygraph.Interaction.moveTouch = function (event, g, context) {
        // If the tap moves, then it's definitely not part of a double-tap.
        g.isTouchMoving = true;
        context.startTimeForDoubleTapMs = null;

        var didZoom = false;
        var touches = getTouches(event, g, context);
        var initialTouches = context.initialTouches;
        var sortVector = function (v) {
            if (v.length == 1) return [v[0]];
            else return [Math.min(v[0], v[1]), Math.max(v[0], v[1])];
        };

        if (touches.length >= 2) {
            var differenceVertical = Math.abs(
                Math.abs(touches[0].pageY - touches[1].pageY) -
                    Math.abs(initialTouches[0].pageY - initialTouches[1].pageY)
            );
            var differenceHorizontal = Math.abs(
                Math.abs(touches[0].pageX - touches[1].pageX) -
                    Math.abs(initialTouches[0].pageX - initialTouches[1].pageX)
            );
            var isHorizontalPinch = differenceHorizontal > differenceVertical;
            context.touchDirections = { x: isHorizontalPinch, y: !isHorizontalPinch };
        }

        if (context.touchDirections.y) {
            var doZoomY = false;
            for (i = 0; i < 1 /*g.axes_.length*/; i++) {
                var valueRange = g.axes_[i].valueRange;
                var valueWindow = g.axes_[i].valueWindow ? g.axes_[i].valueWindow : [valueRange[0], valueRange[1]];
                valueWindow = [Math.min(valueWindow[0], valueWindow[1]), Math.max(valueWindow[0], valueWindow[1])];
                var valueWinSize = valueWindow[1] - valueWindow[0];

                var touchesInitial = [];
                if (initialTouches.length == 1) touchesInitial = [initialTouches[0].dataY];
                else touchesInitial = [initialTouches[0].dataY, initialTouches[1].dataY];
                touchesInitial = sortVector(touchesInitial);

                touchesNow = [];
                if (touches.length == 1) touchesNow = [touches[0].convertedDataY];
                else touchesNow = [touches[0].convertedDataY, touches[1].convertedDataY];
                touchesNow = sortVector(touchesNow);

                valueWindow = [
                    context.initialValueWindow[0] - touchesNow[0] + touchesInitial[0],
                    context.initialValueWindow[1] - touchesNow[0] + touchesInitial[0],
                ];

                if (touches.length > 1) {
                    var ratio = normalizeRatio(
                        (touchesInitial[1] - touchesInitial[0]) / (touchesNow[1] - touchesNow[0])
                    );
                    valueWindow[0] = valueWindow[0] - (ratio - 1) * (touchesNow[0] - context.initialValueWindow[0]);
                    valueWindow[1] = valueWindow[0] + context.initialValueWindowSize * ratio;
                    didZoom = true;
                }
                g.axes_[i].valueWindow = [
                    Math.min(valueWindow[0], valueWindow[1]),
                    Math.max(valueWindow[0], valueWindow[1]),
                ];
            }
        }

        if (context.touchDirections.x) {
            var doZoomX = false;
            for (i = 0; i < 1 /*g.axes_.length*/; i++) {
                // var dateRange = g.dateRange;
                var dateWindow = g.dateWindow_;
                var dateRange = [new Date(g.file_[0][0]).getTime(), new Date(g.file_[g.file_.length - 1][0]).getTime()];

                if (dateWindow == null) dateWindow = $.extend(false, [], dateRange);
                dateWindow = sortVector(dateWindow);

                var touchesInitial = [];
                if (initialTouches.length == 1) touchesInitial = [initialTouches[0].dataX];
                else touchesInitial = [initialTouches[0].dataX, initialTouches[1].dataX];
                touchesInitial = sortVector(touchesInitial);

                touchesNow = [];
                if (touches.length == 1) touchesNow = [touches[0].convertedDataX];
                else touchesNow = [touches[0].convertedDataX, touches[1].convertedDataX];
                touchesNow = sortVector(touchesNow);

                dateWindow = [
                    context.initialDateWindow[0] - touchesNow[0] + touchesInitial[0],
                    context.initialDateWindow[1] - touchesNow[0] + touchesInitial[0],
                ];

                if (touches.length > 1) {
                    var ratio = normalizeRatio(
                        (touchesInitial[1] - touchesInitial[0]) / (touchesNow[1] - touchesNow[0])
                    );
                    dateWindow[0] = dateWindow[0] - (ratio - 1) * (touchesNow[0] - context.initialDateWindow[0]);
                    dateWindow[1] = dateWindow[0] + context.initialDateWindowSize * ratio;
                    didZoom = true;
                }

                var newWinSize = dateWindow[1] - dateWindow[0];
                newWinSize = Math.min(newWinSize, dateRange[1] - dateRange[0]);
                if (dateWindow[1] > dateRange[1]) {
                    dateWindow[1] = dateRange[1];
                    dateWindow[0] = dateRange[1] - newWinSize;
                }

                if (dateWindow[0] < dateRange[0]) {
                    dateWindow[0] = dateRange[0];
                    dateWindow[1] = dateRange[0] + newWinSize;
                }

                g.dateWindow_ = [Math.min(dateWindow[0], dateWindow[1]), Math.max(dateWindow[0], dateWindow[1])];
            }
        }

        g.drawGraph_(false);

        // We only call zoomCallback on zooms, not pans, to mirror desktop behavior.
        if (didZoom && touches.length > 1 && g.getFunctionOption('zoomCallback')) {
            var viewWindow = g.xAxisRange();
            g.getFunctionOption('zoomCallback').call(g, viewWindow[0], viewWindow[1], g.yAxisRanges());
        }
    };
    // MOD END

    // copied from dygraph-interaction-model
    Dygraph.Interaction.movePan = function (event, g, context) {
        context.dragEndX = Dygraph.dragGetX_(event, context);
        context.dragEndY = Dygraph.dragGetY_(event, context);

        var minDate = context.initialLeftmostDate - (context.dragEndX - context.dragStartX) * context.xUnitsPerPixel;
        if (context.boundedDates) {
            minDate = Math.max(minDate, context.boundedDates[0]);
        }
        var maxDate = minDate + context.dateRange;
        if (context.boundedDates) {
            if (maxDate > context.boundedDates[1]) {
                // Adjust minDate, and recompute maxDate.
                minDate = minDate - (maxDate - context.boundedDates[1]);
                maxDate = minDate + context.dateRange;
            }
        }

        if (g.getOptionForAxis('logscale', 'x')) {
            g.dateWindow_ = [Math.pow(Dygraph.LOG_SCALE, minDate), Math.pow(Dygraph.LOG_SCALE, maxDate)];
        } else {
            g.dateWindow_ = [minDate, maxDate];
        }

        // y-axis scaling is automatic unless this is a full 2D pan.
        if (context.is2DPan) {
            var pixelsDragged = context.dragEndY - context.dragStartY;

            // Adjust each axis appropriately.
            for (var i = 0; i < g.axes_.length; i++) {
                var axis = g.axes_[i];
                var axis_data = context.axes[i];
                var unitsDragged = pixelsDragged * axis_data.unitsPerPixel;

                var boundedValue = context.boundedValues ? context.boundedValues[i] : null;

                // In log scale, maxValue and minValue are the logs of those values.
                var maxValue = axis_data.initialTopValue + unitsDragged;
                if (boundedValue) {
                    maxValue = Math.min(maxValue, boundedValue[1]);
                }

                var minValue = maxValue - axis_data.dragValueRange;
                if (boundedValue) {
                    if (minValue < boundedValue[0]) {
                        // Adjust maxValue, and recompute minValue.
                        maxValue = maxValue - (minValue - boundedValue[0]);
                        minValue = maxValue - axis_data.dragValueRange;
                    }
                }
            }
        }

        g.drawGraph_(false);
    };

    // neu
    Dygraph.Interaction.selectByTouch = function (x, y, g) {
        if (g.trovis_touch_left_offset === undefined) {
            var el = $(g.graphDiv).find('canvas');
            if (el.length > 0) {
                g.trovis_touch_left_offset = el.offset().left;
            }
        }

        var leftOffset = g.trovis_touch_left_offset;
        if (g.trovis_touch_left_offset) {
            x = x - leftOffset;
            var idx = g.findClosestRow(x);
            var selectionChanged = g.setSelection(idx);

            var callback = g.getFunctionOption('highlightCallback');
            if (callback && selectionChanged) {
                callback.call(g, event, g.lastx_, g.selPoints_, g.lastRow_, g.highlightSet_);
            }
        }
    };

    var initEvents = function () {
        interactionModel.touchstart = function (event, g, context) {
            if (
                self.isInsideLegend(
                    {
                        pageX: event.touches[0].pageX,
                        pageY: event.touches[0].pageY,
                    },
                    g
                )
            ) {
                event.preventDefault();
                event.stopPropagation();
                $(g.canvas_).parent().find('.dygraph-legend').trigger('click');
            }

            Dygraph.Interaction.startTouch(event, g, context);
        };
        interactionModel.touchmove = function (event, g, context) {
            Dygraph.Interaction.moveTouch(event, g, context);
        };

        interactionModel.touchend = function (event, g, context) {
            g.trovis_touch_left_offset = undefined;
            g.isTouchMoving = false;
            Dygraph.Interaction.endTouch(event, g, context);
        };

        // copied from dygraph-interaction-model and MODIFIED
        interactionModel.mousedown = function (event, g, context) {
            // MOD BEGIN
            /*
            if (self.isInsideLegend(event, g)) {
                event.preventDefault();
                event.stopPropagation();
                $(g.canvas_).parent().find('.dygraph-legend').trigger('click');
            }
            */

            context.trovisInteraction = {
                startMouseX: event.pageX,
                startMouseY: event.pageY,
            };

            context.startPageY = event.pageY;

            if (g.dateWindow_ === null) {
                g.dateWindow_ = g.xAxisExtremes();
            }
            if (typeof g.dateWindow_[0] == 'object') {
                g.dateWindow_[0] = g.dateWindow_[0].getTime();
                g.dateWindow_[1] = g.dateWindow_[1].getTime();
            }

            // MOD END

            // Right-click should not initiate a zoom.
            if (event.button && event.button == 2) return;

            context.initializeMouseDown(event, g, context);

            if (event.altKey || event.shiftKey) {
                Dygraph.startPan(event, g, context);
            } else {
                Dygraph.startZoom(event, g, context);
            }

            // Note: we register mousemove/mouseup on document to allow some leeway for
            // events to move outside of the chart. Interaction model events get
            // registered on the canvas, which is too small to allow this.
            var preprocessEvent = function (event) {
                if (
                    g.trovisContext &&
                    g.trovisContext.isBinary &&
                    context.trovisInteraction &&
                    context.trovisInteraction.startMouseX !== undefined
                ) {
                    if (
                        Math.abs(event.pageY - context.trovisInteraction.startMouseY) >
                        Math.abs(event.pageX - context.trovisInteraction.startMouseX)
                    ) {
                        var newEvent = $.extend(false, {}, event);
                        newEvent.pageY = context.trovisInteraction.startMouseY;
                        return newEvent;
                    }
                }

                return event;
            };

            var mousemove = function (event) {
                event = preprocessEvent(event);

                if (context.isZooming) {
                    // When the mouse moves >200px from the chart edge, cancel the zoom.
                    var d = distanceFromChart(event, g);
                    if (d < DRAG_EDGE_MARGIN) {
                        Dygraph.moveZoom(event, g, context);
                    } else {
                        if (context.dragEndX !== null) {
                            context.dragEndX = null;
                            context.dragEndY = null;
                            g.clearZoomRect_();
                        }
                    }
                } else if (context.isPanning) {
                    // MOD BEGIN
                    tmp = {
                        pageX: event.pageX,
                        clientX: event.clientX,
                        pageY: context.startPageY,
                    };
                    Dygraph.movePan(tmp, g, context);
                    // MOD END
                }
            };

            var mouseup = function (event) {
                event = preprocessEvent(event);

                if (context.isZooming) {
                    if (context.dragEndX !== null) {
                        Dygraph.endZoom(event, g, context);
                    } else {
                        Dygraph.Interaction.maybeTreatMouseOpAsClick(event, g, context);
                    }
                } else if (context.isPanning) {
                    Dygraph.endPan(event, g, context);
                }

                Dygraph.removeEvent(document, 'mousemove', mousemove);
                Dygraph.removeEvent(document, 'mouseup', mouseup);
                context.destroy();
            };

            g.addAndTrackEvent(document, 'mousemove', mousemove);
            g.addAndTrackEvent(document, 'mouseup', mouseup);
        };
    };

    this.isInsideLegend = function (e, g) {
        var x = e.pageX;
        var y = e.pageY;

        var $legend = $(g.canvas_).parent().find('.dygraph-legend');
        var legendPos = $.extend(true, {}, $legend.offset(), { w: $legend.width(), h: $legend.height() });

        var inInterval = function (x, min, len) {
            return x >= min && x <= min + len;
        };

        return inInterval(x, legendPos.left, legendPos.w) && inInterval(y, legendPos.top, legendPos.h);
    };

    this.checkMouseOverLegend = function (e, g) {
        if (this.isInsideLegend(e, g)) {
            $(g.canvas_).css('cursor', 'pointer');
        } else {
            $(g.canvas_).css('cursor', 'initial');
        }
    };

    this.activate = function (g) {
        var self = this;
        interactionModel = g.getOption('interactionModel');
        initEvents();
        Dygraph.movePan = Dygraph.Interaction.movePan;
    };

    this.toString = function () {
        return 'Trovis Team Dygraph Interaction Plugin';
    };
};

Dygraph.PLUGINS.push(Dygraph.Plugins.TrovisInteraction);
